wpbingo.debounce = function(n, t, u) {
    var e;
    return function() {
        var a = this,
            r = arguments,
            i = function() {
                e = null;
                if (!u) n.apply(a, r);
            },
            o = u && !e;

        clearTimeout(e);
        e = setTimeout(i, t);

        if (o) n.apply(a, r);
    };
};

// Make it available globally for Shopify scripts
window.debounce = wpbingo.debounce;